import React, { useEffect, useState, useRef } from "react";
// import PdfViewer from "./PdfViewer";
import { Box, Button, ButtonGroup, Heading, HStack, IconButton, Tooltip, ChakraProvider } from "@chakra-ui/react";
// import { MdWidthFull } from "react-icons/md";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import styles from "./Rawlog.module.css"
import { Resize1, Resize2 } from "./icons";
import Custheme from "../pages/ChakraCustom.js";
// import { useNavigate } from "react-router-dom";

function RawLog(props) {
  const [toggle, setToggle] = useState(true);
  const [data, setData] = useState();
  const logRef = useRef(null);
  // const { hash } = useNavigate();

  useEffect(() => {
    setData(props.data)
  }, [props.data])

  const scrollToTop = () => {
    if (logRef.current) {
      logRef.current.scrollTop = 0;
    }
  };

  const scrollToBottom = () => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  };

  const errorLog = () => {
    const errorregex = new RegExp(/s*![^.?]*/gms);
    let error;
    let errors = [];
    while ((error = errorregex.exec(data)) !== null) {
      errors.push(error)
    }
    let render;
    if (errors.length > 0) {
      render = errors?.map((item, i) => (
        <div key={i} className={styles.errorbox_outer}>
          <p>{item}</p>
        </div>
      ))
    } else {
      render = (<div><p>No error's to show. Please check the Raw log.</p></div>)
    }
    return render;
  }

  return (
    <>
      <div className={styles.header}>
        <HStack
          backgroundColor="var(--primary-main)"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1">
            <Tooltip label="Error Log">
              <Button
                onClick={() => {
                  setToggle(true)
                }}
                bg={toggle === true ? "var(--secondary-main)" : ""}
                color="white"
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "var(--primary-main)" }}
              >Error Log</Button>
            </Tooltip>
            <Tooltip label="Raw Log">
              <Button
                onClick={() => {
                  setToggle(false)
                }}
                color="white"
                bg={toggle === false ? "var(--secondary-main)" : ""}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "var(--secondary-main)" }}
              >Raw Log</Button>
            </Tooltip>
            <Box position={"absolute"} right={0}>
              {props.pdfFull ? (
                <Tooltip label="Minimize PDF">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                    }}
                    size="lg"
                    bg="var(--primary-main)"
                    aria-label="Resize pdf"
                    icon={<Resize2 />}
                    _hover={{ bg: "var(--secondary-main)" }}
                  ></IconButton>
                </Tooltip>
              ) : (
                <Tooltip label="Maximize PDF">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                      // setClientWidth(1);
                    }}
                    size="lg"
                    colorScheme="#f47c0d"
                    aria-label="Resize pdf"
                    icon={<Resize1 />}
                    bg="var(--primary-main)"
                    _hover={{ bg: "var(--secondary-main)" }}
                  ></IconButton>
                </Tooltip>
              )}
            </Box>

          </ButtonGroup>
        </HStack>
      </div>

      <Box
        position="fixed"
        bottom="30px"
        right="30px"
        display="flex"
        flexDirection="column"
        gap="8px"
        zIndex="999"
      >
        <Tooltip label="Scroll to top">
          <IconButton
            size="md"
            colorScheme="orange"
            aria-label="Scroll to top"
            icon={<ChevronUpIcon />}
            onClick={() => logRef.current?.scrollTo({ top: 0, behavior: "smooth" })}
          />
        </Tooltip>

        <Tooltip label="Scroll to bottom">
          <IconButton
            size="md"
            colorScheme="orange"
            aria-label="Scroll to bottom"
            icon={<ChevronDownIcon />}
            onClick={() =>
              logRef.current?.scrollTo({
                top: logRef.current.scrollHeight,
                behavior: "smooth",
              })
            }
          />
        </Tooltip>
      </Box>

      <div
        ref={logRef}
        className={styles.rawlogoutput}
        style={{
          width: "100%",
          overflowY: "auto",
          height: "calc(90vh - 48px)",
          position: "relative",
        }}
      >
        {props.data !== "" ? (
          toggle ? (
            <div style={{ width: "100%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "93%", textWrap: "wrap" }}>{errorLog()}</p></pre>
            </div>
          ) : (
            <div style={{ width: "85%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "600px", textWrap: "wrap" }}>{props.data}</p></pre>
            </div>
          )
        ) : (
          <div style={{ height: "100%", alignItems: "center", display: "flex", justifyContent: 'center', paddingTop: "50px" }}>
            <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "500" }}>No Logs to Show</p>
          </div>
        )}
        <Box
          position="fixed"
          bottom="30px"
          right="30px"
          display="flex"
          flexDirection="column"
          gap="8px"
          zIndex="999"
        >
          <ChakraProvider theme={Custheme}>
            <Tooltip label="Scroll to top">
              <IconButton
                size="md"
                colorScheme="black"
                aria-label="Scroll to top"
                icon={<ChevronUpIcon />}
                onClick={scrollToTop}
              />
            </Tooltip>

            <Tooltip label="Scroll to bottom">
              <IconButton
                size="md"
                colorScheme="black"
                aria-label="Scroll to bottom"
                icon={<ChevronDownIcon />}
                onClick={scrollToBottom}
              />
            </Tooltip>
          </ChakraProvider>
        </Box>
      </div>
    </>
  );
}


export default RawLog;
